<template>
  <div class="-mt-12">
    <h1 class="text-center text-white font-neue-bold text-8xl">
      Alone we can <br />do so little; <br />together we can <br />do so much.
    </h1>
    <h1 class="text-center text-white font-neue-bold text-8xl">
      <a href="mailto:kofisem@gmail.com" target="_blank">Get in touch.</a>
    </h1>
  </div>
</template>

<script>
export default {
  name: "ContactView",
};
</script>
